import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/answer/evaluation/AnswerEvaluationResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/answer/v1/configs`;
	}
	list(e, t) {
		return this.api.get(this.buildPath(`${n.baseUrl}/${e}/evaluations`, t));
	}
	get(e, t) {
		return this.api.get(this.buildPath(`${n.baseUrl}/${e}/evaluations/${t}`));
	}
};
export { n as AnswerEvaluationResource };

//# sourceMappingURL=AnswerEvaluationResource.js.map